module.exports = "/_next/static/images/onboarding-desktop-cac8ebc68eb992540438b5fdf3f916b9.jpg";